import type { Goal } from '@qi/shared';
import { createFileRoute } from '@tanstack/react-router';
import { GoalPickerScreen, VALID_GOALS } from '../components/GoalPickerScreen.tsx';

export interface OnboardingSearch {
  goal?: Goal;
}

export const Route = createFileRoute('/_marketing/onboarding')({
  component: OnboardingPage,
  validateSearch: (search: Record<string, unknown>): OnboardingSearch => {
    const raw = search.goal;
    if (typeof raw === 'string' && (VALID_GOALS as readonly string[]).includes(raw)) {
      return { goal: raw as Goal };
    }
    return {};
  },
});

function OnboardingPage() {
  const { goal: preselectedGoal } = Route.useSearch();
  return <GoalPickerScreen preselectedGoal={preselectedGoal} />;
}
